import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: '',
      component: () => import('@/view/main.vue'),
      children: [
        {
          path: '/',
          name: '/homepage',
          component: () => import('@/view/homePage.vue'),
        },
        {
          path: '/apply',
          name: '/apply',
          component: () => import('@/view/apply/index.vue'),
        },
        {
          path: '/companyProfile',
          name: '',
          component: () => import('@/view/tabs/index.vue'),
          children: [
            {
              path: '/',
              name: '/companyProfile',
              component: () => import('@/view/companyProfile/index.vue'),
            },

          ]
        },
        {
          path: '/teamwork',
          name: '/teamwork',
          component: () => import('@/view/teamwork/index.vue')
        },
        {
          path: '/freeCase',
          name: '/freeCase',
          component: () => import('@/view/freeCase/index.vue')
        },
        {
          path: '/mencenter',
          name: '/mencenter',
          component: () => import('@/view/mencenter/index.vue')/*合作伙伴 */
        },
        {
          path: '/introduction',
          name: '/introduction',
          component: () => import('@/view/introduction/index.vue')/*合作伙伴 */
        },
        {
        path: '/news',
          name: '/news',
          component: () => import('@/view/news/index.vue')/*新闻 */
        },
        {
          path: '/meeting',
          name: '/meeting',
          component: () => import('@/view/meeting/index.vue')/*会议 */
        },
        {
          path: '/certification',
          name: '/certification',
          component: () => import('@/view/certification/index.vue')/*培训认证 */
        },
        {
          path: '/info',
          name: '/info',
          component: () => import('@/view/info/index.vue')/*培训认证 */
        },
        {
          path: '/FrontierTrends',
          name: '/FrontierTrends',
          component: () => import('@/view/FrontierTrends/index.vue')/*前沿趋势 */
        },

      ]
    },
    {
      path: "*",
      name: "/404",
      component: () => import('@/view/404/index.vue')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js